<template>
  <footer class="site-footer">
    <div class="footer-container">
      <div class="footer-content">
        <!-- Logo and Company Info -->
        <div class="footer-brand">
          <img src="../assets/images/logo.png" alt="长江" class="footer-logo" />
          <p class="phone-info">
            需要帮助吗？请致电 <span class="phone-number">021-31787688</span>
          </p>
        </div>

        <!-- Product Center -->
        <div class="footer-links">
          <h3>产品中心</h3>
          <ul>
            <li v-for="category in productCategories" :key="category.id">
              <a href="javascript:;" @click="goToCategory(category.id)">{{ category.categoryName }}</a>
            </li>
          </ul>
        </div>

        <!-- About Us -->
        <div class="footer-links">
          <h3>关于我们</h3>
          <ul>
            <li><router-link to="/about">关于长江</router-link></li>
            <li><router-link to="/blog">媒体中心</router-link></li>
          </ul>
        </div>

        <!-- QR Codes -->
        <div class="footer-qrcode">
          <h3>与我们互动</h3>
          <div class="qrcode-group">
            <div class="qrcode-item">
              <div class="qrcode-image">
                <img src="../assets/images/public_scan.png" alt="公众号二维码" />
              </div>
              <p>公众号</p>
            </div>
            <div class="qrcode-item">
              <div class="qrcode-image">
                <img src="../assets/images/video_scan.png" alt="视频号二维码" />
              </div>
              <p>视频号</p>
            </div>
            <div class="qrcode-item">
              <div class="qrcode-image">
                <img src="../assets/images/douyin.jpg" alt="抖音号二维码" />
              </div>
              <p>抖音号</p>
            </div>
          </div>
        </div>
      </div>

      <!-- Bottom Bar -->
      <div class="footer-bottom">
        <div class="bottom-content">
          <p>
            <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer">沪ICP备2025147604号-1</a>
            |
            <a href="https://beian.mps.gov.cn/" target="_blank" rel="noopener noreferrer">沪公网安备31011202021564号</a>
          </p>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'SiteFooter',
  data() {
    return {
      productCategories: [] // 产品分类列表
    };
  },
  async mounted() {
    await this.fetchProductCategories();
  },
  methods: {
    // 获取产品分类列表
    async fetchProductCategories() {
      try {
        const res = await this.$api.product.getProductCategoryList();
        if (res.code === 200 && res.data) {
          this.productCategories = res.data;
        }
      } catch (error) {
        console.error('获取产品分类失败:', error);
      }
    },
    
    // 跳转到产品页面并滚动到指定分类
    goToCategory(categoryId) {
      this.$router.push({ 
        path: '/products', 
        query: { categoryId: categoryId } 
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.site-footer {
  position: relative;
  background: url('../assets/images/footer-bg.png') center/cover no-repeat;
  color: #fff;
  margin-top: 80px;

  .footer-container {
    
    .footer-content {
      max-width: 1400px;
      margin: 0 auto;
      padding: 80px 40px 60px;
      display: grid;
      grid-template-columns: 2fr 1fr 1fr 1.5fr;
      gap: 60px;

      @media (max-width: 992px) {
        grid-template-columns: 1fr 1fr;
        gap: 40px;
        padding: 60px 30px 40px;
      }

      @media (max-width: 576px) {
        grid-template-columns: 1fr;
        padding: 40px 20px;
      }
    }

    .footer-brand {
      .footer-logo {
        height: 40px;
        margin-bottom: 10px;
        filter: brightness(0) invert(1);
      }

      .company-name {
        font-size: 36px;
        font-weight: bold;
        margin: 10px 0 25px 0;
        color: #fff;
        font-style: italic;
      }

      .phone-info {
        font-size: 14px;
        color: rgba(255, 255, 255, 0.7);
        
        .phone-number {
          color: #FFC107;
          font-weight: 600;
          font-size: 16px;
          margin-left: 5px;
        }
      }
    }

    .footer-links {
      h3 {
        font-size: 16px;
        font-weight: 600;
        margin-bottom: 25px;
        color: #fff;
        position: relative;
        padding-bottom: 12px;

        &::after {
          content: '';
          position: absolute;
          bottom: 0;
          left: 0;
          width: 30px;
          height: 2px;
          background: #ed1c24;
        }
      }

      ul {
        list-style: none;
        padding: 0;
        margin: 0;

        li {
          margin-bottom: 15px;

          a {
            color: rgba(255, 255, 255, 0.7);
            font-size: 14px;
            transition: all 0.3s ease;
            text-decoration: none;

            &:hover {
              color: #fff;
              padding-left: 5px;
            }
          }
        }
      }
    }

    .footer-qrcode {
      h3 {
        font-size: 16px;
        font-weight: 600;
        margin-bottom: 25px;
        color: #fff;
        position: relative;
        padding-bottom: 12px;

        &::after {
          content: '';
          position: absolute;
          bottom: 0;
          left: 0;
          width: 30px;
          height: 2px;
          background: #ed1c24;
        }
      }

      .qrcode-group {
        display: flex;
        gap: 15px;

        .qrcode-item {
          text-align: center;

          .qrcode-image {
            width: 80px;
            height: 80px;
            background: #fff;
            margin-bottom: 8px;
            display: flex;
            align-items: center;
            justify-content: center;
            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
            overflow: hidden;

            img {
              width: 100%;
              height: 100%;
              object-fit: cover;
              display: block;
            }
          }

          p {
            font-size: 12px;
            color: rgba(255, 255, 255, 0.8);
            margin-top: 8px;
          }
        }
      }
    }

    .footer-bottom {
      background: #1F2E33;
      padding: 25px 0;
      margin-top: 40px;

      .bottom-content {
        max-width: 1400px;
        margin: 0 auto;
        padding: 0 40px;
        text-align: center;

        @media (max-width: 768px) {
          padding: 0 20px;
        }

        p {
          font-size: 13px;
          color: rgba(255, 255, 255, 0.6);
          margin: 0;
          line-height: 1.6;

          a {
            color: rgba(255, 255, 255, 0.6);
            text-decoration: none;
            transition: color 0.3s ease;

            &:hover {
              color: #fff;
              text-decoration: underline;
            }
          }
        }
      }
    }
  }
}
</style>